import { render } from "./ComparacaoChart.vue?vue&type=template&id=2eca15d1&scoped=true"
import script from "./ComparacaoChart.vue?vue&type=script&lang=js"
export * from "./ComparacaoChart.vue?vue&type=script&lang=js"

import "./ComparacaoChart.vue?vue&type=style&index=0&id=2eca15d1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eca15d1"]])

export default __exports__